import React from "react";
import { GridContainer, GridItem } from "./MonthlyReport.styles";
import MonthlyReportSummary from "./MonthlyReport.summary";
import MonthlyReportFeesBreakdown from "./MonthlyReport.feesBreakdown";
import MonthlyReportCommissionConfig from "./MonthlyReport.commissionConfig";
import MonthlyReportMerchantsTable from "./MonthlyReport.merchantsTable";

const MonthlyReportISO = ({ reportData }) => {
  const { summary, commission_config, merchants } = reportData;

  return (
    <GridContainer spacing={0}>
      <MonthlyReportSummary summary={summary} />
      <MonthlyReportFeesBreakdown summary={summary} />
      <MonthlyReportCommissionConfig commission_config={commission_config} userType="iso" />
      <GridItem xs={12} padding="0 0 15px 0">
        <MonthlyReportMerchantsTable merchants={merchants} title="Merchants" />
      </GridItem>
    </GridContainer>
  );
};

export default MonthlyReportISO;

